module.exports = __webpack_public_path__ + "static/media/wave-terms-and-conditions.51347ffd.pdf";